import { PLATFORM_ROLE } from "common/Constants/PlatformRole.constants";
import { hasStoredSelectedCustomer } from "./CustomerSelection.utils";

export const normalizeRole = (role) => String(role ?? "").toLowerCase().trim();

export const isPlatformAdminRole = (role) =>
  normalizeRole(role) === PLATFORM_ROLE.PLATFORM_ADMIN.toLowerCase();

export const isNonePlatformRoleValue = (role) =>
  normalizeRole(role) === PLATFORM_ROLE.NONE.toLowerCase();

export const isPlatformAdminProfile = (profile = {}) =>
  isPlatformAdminRole(profile?.platformRole);

export const isNonePlatformRole = (profile = {}) =>
  isNonePlatformRoleValue(profile?.platformRole);

export const platformAdminUsesCustomerContextFromMe = (profile = {}) =>
  isPlatformAdminProfile(profile) &&
  Boolean(profile?.sessionFromMe) &&
  hasStoredSelectedCustomer();

export const getCustomerAccessListFromProfile = (profile = {}) => {
  if (Array.isArray(profile?.customerAccess)) {
    return profile.customerAccess;
  }
  if (Array.isArray(profile?.customerAccesses)) {
    return profile.customerAccesses;
  }
  return [];
};
export const getProfileDisplayRoles = (profile = {}) => {
  const useCustomerScopedRoles =
    !isPlatformAdminProfile(profile) ||
    platformAdminUsesCustomerContextFromMe(profile);

  if (useCustomerScopedRoles) {
    const customerRoles =
      profile?.effectiveAccess?.customerRoles ??
      profile?.activeCustomerRoles ??
      profile?.customerRoles ??
      [];

    if (Array.isArray(customerRoles) && customerRoles.length) {
      return customerRoles
        .map((role) => String(role ?? "").trim())
        .filter(Boolean);
    }
  }

  if (profile?.platformRole) {
    return [String(profile.platformRole).trim()].filter(Boolean);
  }
  return [];
};
export const hasMultiCustomerAccess = (profile = {}) =>
  getCustomerAccessListFromProfile(profile).length > 1;

export const shouldShowCustomerDropdown = (profile = {}) => {
  if (isPlatformAdminProfile(profile)) {
    return getCustomerAccessListFromProfile(profile).length >= 1;
  }
  if (profile?.sessionFromMe) {
    return getCustomerAccessListFromProfile(profile).length >= 1;
  }
  return hasMultiCustomerAccess(profile);
};
